/* jshint esversion: 6 */
import React from 'react';
import ChooserHeader from 'app/components/SubaccountSelector/ChooserHeader.jsx';
import ChooserMain from 'app/components/SubaccountSelector/ChooserMain.jsx';

class DiscordOutput extends React.Component {
    render() {
        return (
            <div>
                <ChooserHeader
                    {...this.props}
                    error={this.props.error}
                    headerCopy="Select a Channel"/>
                <ChooserMain
                    {...this.props}
                    allConnectedMessage={"You've already connected all your channels to dlvr.it"}
                    unavailableMessage={"Channels you've already connected"}
                    typeLabel="channel"/>
            </div>
        );
    }
}

DiscordOutput.displayName = "DiscordOutput";

export default DiscordOutput;
